(function () {
  'use strict';

  function initGallery(root) {
    if (root.dataset.scrollGalleryInit) return;
    root.dataset.scrollGalleryInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-scroll-gallery-slide]'));
    var thumbBtns = Array.prototype.slice.call(root.querySelectorAll('[data-scroll-gallery-thumb-btn]'));
    var thumbRail = root.querySelector('[data-scroll-gallery-thumb]');

    if (!slides.length || !thumbBtns.length) return;

    var activeIndex = 0;
    var clickScrolling = false;
    var clickScrollTimeout = null;

    function setActive(index) {
      if (index === activeIndex && thumbBtns[index].classList.contains('is-active')) return;
      activeIndex = index;
      thumbBtns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var activeBtn = thumbBtns[index];
      if (activeBtn && thumbRail) {
        var railRect = thumbRail.getBoundingClientRect();
        var btnRect = activeBtn.getBoundingClientRect();
        var isVertical = thumbRail.scrollHeight > thumbRail.clientHeight;
        if (isVertical) {
          if (btnRect.top < railRect.top || btnRect.bottom > railRect.bottom) {
            activeBtn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        } else {
          if (btnRect.left < railRect.left || btnRect.right > railRect.right) {
            activeBtn.scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
          }
        }
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (clickScrolling) return;
        var best = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) {
              best = entry;
            }
          }
        });
        if (best) {
          var idx = parseInt(best.target.getAttribute('data-index'), 10);
          if (!isNaN(idx)) setActive(idx);
        }
      },
      {
        root: null,
        rootMargin: '-40% 0px -40% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      }
    );
    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        var target = slides[idx];
        if (!target) return;
        clickScrolling = true;
        setActive(idx);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        clearTimeout(clickScrollTimeout);
        clickScrollTimeout = setTimeout(function () {
          clickScrolling = false;
        }, 900);
      });
    });

    setActive(0);
  }

  function initAll() {
    document.querySelectorAll('[data-scroll-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-scroll-gallery]').forEach(function (el) {
      delete el.dataset.scrollGalleryInit;
      initGallery(el);
    });
  });
})();
